module.exports = __webpack_public_path__ + "img/logo-inverted.42f77a53.png";